export const MENU_LIST = "MENU_LIST"
export const MYMEAL_COUNT = "MYMEAL_COUNT"